import type * as Types from '@formic/fusion-graphql/schema';

import { gql } from 'urql';
import * as Urql from 'urql';
export type Omit<T, K extends keyof T> = Pick<T, Exclude<keyof T, K>>;
export type PartialRespondentsCountFieldsFragment = { submissionDate?: Types.Maybe<string>, receipt?: Types.Maybe<string> };

export type PartialRespondentsCountQueryVariables = Types.Exact<{ [key: string]: never; }>;


export type PartialRespondentsCountQuery = { partialRespondents: Array<PartialRespondentsCountFieldsFragment> };

export const PartialRespondentsCountFieldsFragmentDoc = /*#__PURE__*/ gql`
    fragment PartialRespondentsCountFields on Respondent {
  submissionDate
  receipt
}
    `;
export const PartialRespondentsCountDocument = /*#__PURE__*/ gql`
    query partialRespondentsCount {
  partialRespondents {
    ...PartialRespondentsCountFields
  }
}
    ${PartialRespondentsCountFieldsFragmentDoc}`;

export function usePartialRespondentsCountQuery(options: Omit<Urql.UseQueryArgs<PartialRespondentsCountQueryVariables>, 'query'> = {}) {
  return Urql.useQuery<PartialRespondentsCountQuery>({ query: PartialRespondentsCountDocument, ...options });
};